'use client';

import type { ReactNode } from 'react';

import { ProductMarkThreeOrnament } from './product-mark-three-ornament';
import { createRadioDemonThreeScene } from './radio-demon-three-scene';

type RadioDemonThreeOrnamentProps = {
  /** Static logo markup shown until (and unless) the WebGL scene is live. */
  children: ReactNode;
};

/**
 * Client island wrapping the Radio Demon showcase mark with the extruded
 * Three.js scene. Delegates lifecycle to ProductMarkThreeOrnament.
 */
export function RadioDemonThreeOrnament({
  children,
}: RadioDemonThreeOrnamentProps) {
  return (
    <ProductMarkThreeOrnament createScene={createRadioDemonThreeScene}>
      {children}
    </ProductMarkThreeOrnament>
  );
}
